<div class="pull-right">
  <button
    class="closebtn"
    mat-button
    color="accent"
    [attr.id]="buildConfirmPopupId('btn-dismiss')"
    (click)="cancelAction()">
    <span class="icon-ic-close popup_close"></span>
  </button>
</div>
<div class="dialog-container">
  <h5 class="margin-top margin-bottom">{{ data.title | translate }}</h5>

  <div class="dialog-content" [innerHTML]="data.message | translate">
  </div>

  <form id="form" [formGroup]="form">
    @if (justificationRequired) {
      <div class="p-b-s">
        <div class="form-value textalign-left p-b-s"> Justification <span class="color-error">*</span></div>
        <div class="justificationField">
          <mat-form-field class="Justification w-100">
            <textarea matInput formControlName="Justification" #justification placeholder="Please add a justification for rejecting the access request*" maxlength="500" name="Justification" id="Justification" cols="10" rows="5"></textarea>
            <mat-hint align="end" class="font-s m-t-m">{{justification.value.length}}/500</mat-hint>
            @if (form.controls.Justification.errors?.required) {
              <mat-error
                class="m-t-m"
                >
                Justification is required
              </mat-error>
            }
            @if (form.controls.Justification.errors?.minlength) {
              <mat-error
                class="m-t-m w-300"
                >
                Justification field must have more than 10 characters
              </mat-error>
            }
            @if (form.controls.Justification.errors?.maxlength) {
              <mat-error
                class="m-t-m w-350"
                >
                Justification field must not have more than 500 characters
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    }
  </form>

  <div>
    @if (data.isOkButton) {
      <button
        mat-button
        color="primary"
        class="confirm-btn primary-hover"
        mat-raised-button
        [attr.id]="buildConfirmPopupId('btn-confirm')"
        (click)="confirmed()"
        >
        {{ data.confirmLable | translate }}
      </button>
    }
    <button
      mat-button
      (click)="dismiss()"
      color="primary"
      class="mat-button confirm-btn secondary-hover"
      [attr.id]="buildConfirmPopupId('btn-cancel')"
      >
      {{ data.cancelLabel | translate }}
    </button>
  </div>
</div>
